import React from 'react';

/**
 * Keeps track of the ExistingItem. Useful in Thread.
 * @type {import('react').Context<Item>}
 */
export default React.createContext({});
